/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rmf_Banner_Unknown_ErrorInputs */

const en_rmf_banner_unknown_error = /** @type {(inputs: Rmf_Banner_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unknown error`)
};

const fr_rmf_banner_unknown_error = /** @type {(inputs: Rmf_Banner_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erreur inconnue`)
};

const ms_sg2_rmf_banner_unknown_error = /** @type {(inputs: Rmf_Banner_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ralat tidak diketahui`)
};

/**
* | output |
* | --- |
* | "unknown error" |
*
* @param {Rmf_Banner_Unknown_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_banner_unknown_error = /** @type {((inputs?: Rmf_Banner_Unknown_ErrorInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Banner_Unknown_ErrorInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_banner_unknown_error(inputs)
	if (locale === "fr") return fr_rmf_banner_unknown_error(inputs)
	return ms_sg2_rmf_banner_unknown_error(inputs)
});